import { configureStore } from '@reduxjs/toolkit';
import userFleetSlice from './userFleetSlice';

export default configureStore({
  reducer: {
    userfleet: userFleetSlice
  }
});
